const DOCUSIGN_MODAL = {
  modaltitle: 'Termo Geral de Contratação do Zé Delivery de Bebidas',
  successSignContract: 'Contrato assinado com sucesso!',
  errorSignContract: 'Erro ao salvar contrato. Tente novamente.',
  errorLoadContract: 'Erro ao carregar contrato. Tente novamente.',
}

export default DOCUSIGN_MODAL
